import { Box } from '@mui/material';
import { Link } from 'react-router';

const CustomLink = ({ href, ...props }: any) => (
  <Box component={Link} to={href} {...props} viewTransition prefetch="intent" />
);

export default CustomLink;
